import React from 'react';
import { View, Switch, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { DesktopSectionHeader } from '@/components/residents/desktop/myAccount/DesktopSectionHeader';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';

export const AppearanceView: React.FC = () => {
  const { mode, colors, semantic, components, toggleTheme } = useThemeColors();
  const isDarkMode = mode === 'dark';

  return (
    <View style={[styles.root, { backgroundColor: colors.bg.modal }]}>
      <DesktopSectionHeader
        title="Appearance"
        subtitle="Customize how the app looks"
        containerStyle={[styles.header, { borderBottomColor: semantic.border.secondary }]}
        titleStyle={[styles.headerTitle, { color: semantic.text.primary }]}
        subHeaderContainerStyle={[styles.subHeader, { borderBottomColor: semantic.border.secondary }]}
        subHeaderTextStyle={[styles.subHeaderText, { color: semantic.text.primary }]}
      />
      <View style={styles.body}>
        <View style={[styles.toggleRow, { borderBottomColor: semantic.border.secondary }]}>
          <View style={styles.toggleCopy}>
            <Text style={[styles.toggleLabel, { color: semantic.text.primary }]}>Dark Mode</Text>
            <Text style={[styles.toggleSub, { color: semantic.text.tertiary }]}>
              Switch between light and dark themes
            </Text>
          </View>
          <Switch
            value={isDarkMode}
            onValueChange={toggleTheme}
            trackColor={{ false: semantic.border.secondary, true: PRIMITIVE_COLORS.resioBlue }}
            thumbColor={components.toggle.thumb}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: { flex: 1 },
  header: { borderBottomWidth: 1, paddingHorizontal: 20, paddingVertical: 14 },
  headerTitle: { fontWeight: '800', fontSize: 18 },
  subHeader: { borderBottomWidth: 1, paddingHorizontal: 20, paddingVertical: 14 },
  subHeaderText: { fontWeight: '600' },
  body: { paddingVertical: 24, paddingHorizontal: 20 },
  toggleRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 12, borderBottomWidth: 1 },
  toggleCopy: { flex: 1, paddingRight: 12 },
  toggleLabel: { fontSize: 16, fontWeight: '700' },
  toggleSub: { fontSize: 14, marginTop: 2 },
});

export default AppearanceView;
